import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/atlassian/pipelines/agent/build/platform/services/design-system-docs/src/__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/templates/page.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "contribute-a-small-fix-or-enhancement-atlassians-only"
    }}>{`Contribute a small fix or enhancement (Atlassians only)`}</h2>
    <p>{`A design system is never complete. It depends on contributions from Atlassian teams, so we’d love
your help!`}</p>
    <p>{`Atlassians can contribute by posting in our
`}<a parentName="p" {...{
        "href": "https://go.atlassian.com/help-design-system"
      }}>{`slack channel`}</a>{`.`}</p>
    <p>{`If you don’t work for Atlassian and have some feedback, let us know in the feedback collector
available on each page of the site.`}</p>
    <p>{`We are currently accepting contributions through:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Fixes`}</strong>{`, such as removing bugs in the code, errors in Figma library components, and editing
confusing documentation.`}</li>
      <li parentName="ul"><strong parentName="li">{`Small`}</strong>{` enhancements, such as adding a new icon to the existing icon library.`}</li>
    </ul>
    <p>{`These changes don’t break existing behavior and can be confined to minimize impact across the design
system.`}</p>
    <h3 {...{
      "id": "we-cant-accept-large-contributions-right-now"
    }}>{`We can’t accept large contributions right now`}</h3>
    <p>{`Considering a design system component or pattern takes time. We have to think about every app and
its use case, multiple brands, API design, and guidelines that apply to everyone.`}</p>
    <p>{`At this time, we are unable to take these types of contributions:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Major enhancements`}</strong>{`, such as adding a new feature to a component, or altering a property like a
timeout on a flag.`}</li>
      <li parentName="ul"><strong parentName="li">{`New components`}</strong>{` or patterns, such as data visualization.`}</li>
    </ul>
    <p>{`These changes require system-wide coordination and impact code, design, and documentation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      